<div class="component-wrapper">
    <div class="logo-wrapper">
        <img class="logo" src="/assets/ace_logo_xfound_header.png" alt="xfound-logo"/>
    </div>
    <form class="form" (ngSubmit)="reset()" [formGroup]="resetPasswordForm">
        <h2 class="title" translate>auth.reset_password</h2>
        <kendo-formfield class="password">
            <kendo-label [for]="password" text="{{'register.password' | translate}}"></kendo-label>
            <kendo-textbox #password
            placeholder="{{'register.password' | translate}}"
            formControlName="passwort"
            showSuccessIcon="initial"
            showErrorIcon="initial"
             ></kendo-textbox>
            <kendo-formerror *ngFor="let errorMessage of passwortErrorMessages">{{errorMessage}}</kendo-formerror>
        </kendo-formfield>
        <kendo-formfield class="passwordW">
            <kendo-label [for]="passwordW" text="{{'register.repeatPassword' |translate}}"></kendo-label>
            <kendo-textbox #passwordW
            placeholder="{{'register.repeatPassword' |translate}}"
            formControlName="passwortWiederholen"
            showSuccessIcon="initial"
            showErrorIcon="initial"
             ></kendo-textbox>
            <kendo-formerror *ngFor="let errorMessage of passwortWiderholenErrorMessages">{{errorMessage}}</kendo-formerror>
        </kendo-formfield>
        <div class="submit-wrapper">
            <button kendoButton class="reset" type="submit" [disabled]="resetPasswordForm.invalid || isLoading" [innerHTML]="'resetpasword.submit' |translate"></button>
        </div>
    </form>
</div>